import { FacilitatorMessagingFields as Fields } from '../types/FacilitatorMessaging';
import { ErrorSetterByField, InputValidationHelper } from '../types/InputValidator';
import { validateField, validateIsEmpty, validateNotEmptyAndMaxLength, validateSection } from './validation.utils';

interface Params {
  title: string;
  message: string;
  teamName?: string;
  participantLogin?: string;
}

export const MSG_TITLE_MAX_LENGTH = 120;
export const MSG_CONTENT_MAX_LENGTH = 2000;

export const facilitatorMessagingValidator: (
  fields: Params,
  errors: Params,
  errorSetterByField: ErrorSetterByField<Fields>
) => {
  isValidSection: (setErrors?: boolean) => boolean;
  isValidField: (field: Fields, setError?: boolean) => boolean;
} = (fields, errors, errorSetterByField: Map<Fields, (error: string) => void>) => {
  const validatorHelperByField = new Map<Fields, InputValidationHelper>([
    [Fields.TEAM_NAME, validateIsEmpty(fields[Fields.TEAM_NAME], errors[Fields.TEAM_NAME] as string)],
    [Fields.PARTICIPANT_LOGIN, validateIsEmpty(fields[Fields.PARTICIPANT_LOGIN], errors[Fields.PARTICIPANT_LOGIN] as string)],
    [Fields.MESSAGE, validateNotEmptyAndMaxLength(fields[Fields.MESSAGE], MSG_CONTENT_MAX_LENGTH, errors[Fields.MESSAGE] as string)],
    [Fields.TITLE, validateNotEmptyAndMaxLength(fields[Fields.TITLE], MSG_TITLE_MAX_LENGTH, errors[Fields.TITLE] as string)],
  ]);

  const isValidField = (field: Fields, setError = true) => {
    return validateField<Fields>(validatorHelperByField, errorSetterByField, field, setError);
  };

  const isValidSection = (setErrors = false): boolean => {
    return validateSection<Fields>(validatorHelperByField, errorSetterByField, setErrors);
  };

  return {
    isValidSection,
    isValidField,
  };
};
